import styled from "styled-components/macro";
import { DefaultFont } from "../../../styles/fonts";
import { Button } from "antd";
import { ChevronRight } from "@styled-icons/bootstrap";

export const Root = styled.div`
  height: 100%;
  padding: 32px 24px;
`;
export const Heading = styled.div`
  ${DefaultFont};
  font-size: 16px;
  font-weight: ${(p) => p.theme.font.weightMedium};
  color: ${(p) => p.theme.colors.chatTextColor};
  margin-bottom: 16px;
`;
export const ProfilePicture = styled.img`
  border-radius: 50%;
  margin-bottom: 24px;
  height: 144px;
`;
export const FeaturesBlock = styled.div`
  display: flex;
  align-items: flex-start;
  gap: 10px;
  margin-bottom: 16px;
`;
export const FeaturesIcon = styled.div`
  color: ${(p) => p.theme.colors.midGrey};
  svg {
    height: 20px;
  }
  display: flex;
  align-items: center;
`;
export const FeaturesValue = styled.div`
  color: ${(p) => p.theme.colors.midGrey};
`;

export const ProfileButton = styled(Button)`
  ${DefaultFont};
  display: flex;
  align-items: center;
  width: 100%;
  padding-left: 0;
  padding-right: 0;
  margin-bottom: 8px;
  color: ${(p) => p.theme.colors.chatTextColor};

  &:hover {
    background: none !important;
  }

  @media ${(props) => props.theme.media.phone} {
    font-size: 14px;
  }
`;

export const ProfileButtonText = styled.div`
  flex-grow: 1;
  text-align: left;
`;

export const LinkButton = styled(Button)`
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  padding-left: 0;
  padding-right: 0;

  &:hover {
    background: none !important;
  }
`;

export const LinkButtonText = styled.div`
  text-align: start;
  text-wrap: wrap;
`;
export const LinkButtonsContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
`;

export const Delimiter = styled.div`
  margin: 24px 0;
  border-bottom: 1px solid #d9d9d9;
`;
export const Chevron = styled(ChevronRight)`
  height: 80%;
`;
